import { supabase } from '@/shared/lib/supabase'
import type { StoryHistoryItem } from '../types'

export interface SaveStoryPayload {
  draftNotes: string
  generatedStories: string
  inputTokens: number | null
  outputTokens: number | null
}

export async function saveStoryHistory(payload: SaveStoryPayload): Promise<StoryHistoryItem> {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session) throw new Error('Not authenticated')

  const { data, error } = await supabase
    .from('story_history')
    .insert({
      user_id: session.user.id,
      draft_notes: payload.draftNotes,
      generated_stories: payload.generatedStories,
      input_tokens: payload.inputTokens,
      output_tokens: payload.outputTokens,
    })
    .select()
    .single()

  if (error) throw error
  return mapRow(data)
}

export async function fetchStoryHistory(): Promise<StoryHistoryItem[]> {
  const { data, error } = await supabase
    .from('story_history')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(50)

  if (error) throw error
  return (data ?? []).map(mapRow)
}

export async function deleteStoryHistory(id: string): Promise<void> {
  const { error } = await supabase
    .from('story_history')
    .delete()
    .eq('id', id)

  if (error) throw error
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapRow(row: any): StoryHistoryItem {
  return {
    id: row.id,
    userId: row.user_id,
    draftNotes: row.draft_notes,
    generatedStories: row.generated_stories,
    inputTokens: row.input_tokens,
    outputTokens: row.output_tokens,
    createdAt: row.created_at,
  }
}
